import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({
    baseURL: API,
    timeout: 15000,
});

export const api = {
    siteInfo: () => http.get("/site-info").then((r) => r.data),
    practitioner: () => http.get("/practitioner").then((r) => r.data),
    treatments: (params = {}) =>
        http.get("/treatments", { params }).then((r) => r.data),
    treatment: (slug) => http.get(`/treatments/${slug}`).then((r) => r.data),
    packages: () => http.get("/packages").then((r) => r.data),
    posts: (limit = 50) =>
        http.get("/posts", { params: { limit } }).then((r) => r.data),
    post: (slug) => http.get(`/posts/${slug}`).then((r) => r.data),
    faqs: () => http.get("/faqs").then((r) => r.data),
    testimonials: () => http.get("/testimonials").then((r) => r.data),
    doshas: () => http.get("/doshas").then((r) => r.data),
    pillars: () => http.get("/pillars").then((r) => r.data),
    elements: () => http.get("/elements").then((r) => r.data),
};

export default api;
